module.exports = __webpack_public_path__ + "img/聊城万晟二手车交易市场.10f88f70.png";